
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";

import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import { Button } from "../../controls";
import ReportPrintButton from "../reports/ReportPrintButton";

//------------------------------------------------
// Reusable Inventory History Content
//------------------------------------------------
const InventoryHistoryContent = ({
  viewData,
  t,
}) => {
  const productName = viewData?.product?.name || "";

  // Sort without modifying the original Redux data.
  const inventoryHistory = [
    ...(viewData?.invUsers || []),
  ].sort((a, b) => Number(b.id) - Number(a.id));

  return (
    <Box>
      {/* Title */}
      <Box sx={{ textAlign: "center", mt: 2, mb: 3 }}>
        <Typography
          variant="h5"
          className="fs-22 gray-color fw-5 tx-upp mb-10"
        >
          '{productName}' {t("addedDetails")}
        </Typography>

        <div className="bs-bottom mx-w-80 m-auto mb-30" />
      </Box>

      {/* Inventory History Table */}
      <TableContainer className="mt-20">
        <Table size="small" aria-label="inventory history">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>
                {t("username")}
              </TableCell>

              <TableCell sx={{ fontWeight: "bold" }}>
                {t("inventoryAdded")}
              </TableCell>

              <TableCell sx={{ fontWeight: "bold" }}>
                {t("date")}
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {inventoryHistory.map((inv, index) => (
              <TableRow key={inv.id ?? index}>
                <TableCell>
                  {[
                    inv.user?.firstName,
                    inv.user?.lastName,
                  ]
                    .filter(Boolean)
                    .join(" ")}
                </TableCell>

                <TableCell>
                  {inv.addedInv ?? ""}
                </TableCell>

                <TableCell>
                  {inv.date ?? ""}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

//------------------------------------------------
// View Inventory Details
//------------------------------------------------
const ViewDetails = (props) => {
  const { t } = useTranslation();

  const { viewData, setShowForm } = props;

  const reportRef = useRef(null);

  const productName = viewData?.product?.name || "";

  const reportTitle = `${productName} - ${t(
    "addedDetails"
  )}`;

  return (
    <Grid container className="p-20">
      {/* Print Preview Button */}
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mb: 1,
        }}
      >
        <ReportPrintButton
          reportRef={reportRef}
          paperSize="Letter"
          reportTitle={reportTitle}
        />
      </Grid>

      {/* Screen Inventory History */}
      <Grid item xs={12}>
        <InventoryHistoryContent
          viewData={viewData}
          t={t}
        />
      </Grid>

      {/* Print-only Inventory History */}
      <Grid item xs={12}>
        <Box
          ref={reportRef}
          className="inventory-details-print"
          sx={{
            position: "absolute",
            left: "-10000px",
            top: 0,
            width: "1000px",
            backgroundColor: "#fff",
            color: "#000",
            p: 2,
          }}
        >
          <InventoryHistoryContent
            viewData={viewData}
            t={t}
          />
        </Box>
      </Grid>

      {/* Close Button */}
      <Grid
        item
        xs={12}
        className="tx-center mt-40"
      >
        <Button
          onClick={() => setShowForm(false)}
          className="btn-error"
          size="large"
          sx={{ minWidth: "150px" }}
        >
          {t("close")}
        </Button>
      </Grid>
    </Grid>
  );
};

export default ViewDetails;
